import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

const supportedActions = [
  'GET_COMMENTS',
  'GET_NEW_COMMENTS',
  'GET_OLDER_COMMENTS',
];

export const consts = createReqConsts(
  'communities',
  'commentsListFetch',
  supportedActions,
);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'posts',
  type: 'get',
  slug: [
    {
      type: 'payload',
      selector: ['postId'],
    },
    'comments',
    {
      type: 'payload.query',
      queryParameter: 'limit',
      selector: 'limit',
    },
    {
      type: 'payload.query',
      queryParameter: 'offset',
      selector: 'offset',
    },
  ],
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/communities/commentsListFetch.js